import { render, staticRenderFns } from "./ReceiptForm.vue?vue&type=template&id=87261b1c&scoped=true&"
import script from "./ReceiptForm.vue?vue&type=script&lang=js&"
export * from "./ReceiptForm.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptForm.vue?vue&type=style&index=0&id=87261b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87261b1c",
  null
  
)

export default component.exports